<mat-form-field subscriptSizing="dynamic" color="accent" class="lv-material-date"
                [hideRequiredMarker]="true" [floatLabel]="'auto'">
  <div class="lv-date-input-field"
       [ngClass]="{'lv-date-input-field-error': (isError() && !hasFocus) || showMeldung}">
    <input lvDatumValidator matInput [matDatepicker]="picker" (focus)="hasFocus = true"
           [disabled]="disabled"
           (blur)="onBlur()" [placeholder]="placeholder" [(ngModel)]="model" #date="ngModel"
           [name]="name"
           [autocomplete]="autocomplete"
           maxlength="10" [errorStateMatcher]="dateMatcher">
  </div>
  <mat-hint *ngIf="showHint">{{'COMMON.DATE_FORMAT' | translate}}</mat-hint>
  <mat-error *ngIf="getError() as error" class="lv-control-error" [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}" (click)="onErrorClick()">
    {{error}}
  </mat-error>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [startAt]="startDate"></mat-datepicker>
</mat-form-field>
